import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import { AssignDevicesContext, IAssignDevicesContext } from '../../devicesFormState/devicesFormContext';
import { assignDevices } from 'backend/restaurants';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, typeOfModalWindow, dataForAssign } =
		useContext<IAssignDevicesContext>(AssignDevicesContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleRedirect = useCallback(() => {
		history.push('/clients/restaurants');
	}, [history]);

	const handleSubmitMainInfo = useCallback(async () => {
		if (dataForAssign) {
			try {
				showLoader();
				await assignDevices(dataForAssign);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForAssign]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<>
			<div className={containerClasses}>
				<ModalToConfirm
					onConsentEvent={handleRedirect}
					onFailureEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
					description="cancelSaveInfo"
				/>
				<ModalToConfirm
					onConsentEvent={handleSubmitMainInfo}
					onFailureEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'toConfirmSubmit'}
					description="saveInfo"
				/>
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'success'}
					description="savedSuccessfully"
				/>
				<ModalSentError
					onConsentEvent={handleCloseModal}
					isVisible={typeOfModalWindow === 'error'}
					description="errorWhileSaving"
				/>
			</div>
		</>
	);
};

export default ModalWindows;
